import { render } from "./Lexique.vue?vue&type=template&id=ad36fe16"
import script from "./Lexique.vue?vue&type=script&lang=js"
export * from "./Lexique.vue?vue&type=script&lang=js"

import "./Lexique.vue?vue&type=style&index=0&id=ad36fe16&lang=scss"

import exportComponent from "/var/www/vhosts/universalmusic.fr/sites/crm/www/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__